// src/components/Dashboard/RobotsSection.tsx
import React from 'react';
import { Robot } from '../../types'; // Предполагается, что тип Robot определен
import RobotCard from './RobotCard';

interface RobotsSectionProps {
  robots: Robot[];
}

const RobotsSection: React.FC<RobotsSectionProps> = ({ robots }) => {
  return (
    <section className="robots-section" id="robots">
      <h2>🤖 Доступные роботы</h2>
      <div className="robots-grid" id="robotsList">
        {/* Проверяем, есть ли роботы для отображения */}
        {robots && robots.length > 0 ? (
          robots.map((robot) => (
            <RobotCard key={robot.id} robot={robot} />
          ))
        ) : (
          <p>Роботы не найдены.</p>
        )}
      </div>
    </section>
  );
};

export default RobotsSection;